import React from 'react';
import { ScanSearch } from 'lucide-react';
import BreedIdentifier from '../../components/BreedIdentifier';

export default function BreedId() {
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-10 border-b border-border bg-background/95 px-4 py-3 backdrop-blur">
        <h1 className="text-base font-extrabold">Breed Identifier</h1>
        <p className="text-xs text-muted-foreground">Snap a photo and let AI guess your cat's breed</p>
      </header>
      <div className="px-4 py-4">
        <div className="mb-4 flex items-start gap-3 rounded-2xl bg-accent/60 p-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white"><ScanSearch className="h-5 w-5 text-[hsl(var(--coral))]" /></div>
          <p className="text-sm text-accent-foreground">Not sure what your cat is? This is especially handy for <span className="font-bold">mixed-breed cats</span> — you'll get the most likely breeds with a confidence score.</p>
        </div>
        <BreedIdentifier withCatActions />
      </div>
    </div>
  );
}
